const Profile = () => {
  return (
    <div>profile</div>
  )
}

export default Profile;
